<template>
    <div class="public-modal" @touchmove.prevent>
      <div class="modal-mask">
        <div class="modal-content">
          <div class="modal-header">
            <img src="/eosrent/images/off.png" alt="" @click="close">
          </div>

          <div class="cpu-rent-explain" v-if="refs.type === 'CPU_RENT'">
            <h3>{{$t('explain.cpu-title')}}</h3>
            <p>1、{{$t('explain.cpu-item1')}}</p>
            <p>2、{{$t('explain.cpu-item2')}}</p>
            <p>3、{{$t('explain.cpu-item3')}}</p>
            <p>4、{{$t('explain.cpu-item4')}}</p>
          </div>

          <div class="eos-payment-explain" v-if="refs.type === 'EOS_PAY'">
            <h3>{{$t('explain.eos-title')}}</h3>
            <p>1、{{$t('explain.eos-item1')}}</p>
            <p>2、{{$t('explain.eos-item2')}}</p>
            <div class="images" v-viewer>
              <img class="eos-explain-icon" src="/eosrent/images/eos-explain.png" alt="">
            </div>
            <P>3、{{$t('explain.eos-item3')}}</P>
          </div>

          <!--<div class="eth-payment-explain" v-if="refs.type === 'ETH_PAY'">-->
            <!--<h3>{{$t('explain.eth-title')}}</h3>-->
            <!--<p>1、请一次性支付上述要求的“支付金额”。单次支付金额低于要求时将导致支付无效;</p>-->
            <!--<p>2、付款后需要3-5分钟的订单确认时间，确认后系统将自动发出CPU 资源。</p>-->
            <!--<div class="images" v-viewer>-->
              <!--<img class="eos-explain-icon" src="/eosrent/images/eth-explain.png" alt="">-->
            <!--</div>-->
            <!--<p>3、注意，若您需要修改Gas Limit，Gas Limit数值不能低于22224;</p>-->
            <!--<p>4、交易被确认后，系统将自动抵押CPU 资源，您可以用订单号在“订单查询”页面查询该订单。</p>-->
          <!--</div>-->

        </div>
      </div>
    </div>
</template>

<style lang="less" scoped>

</style>

<script>
export default {
  props: ['refs'],
  data () {
    return {}
  },
  mixins: [],
  components: {},
  mounted () {

  },
  methods: {
    close () {
      this.refs.showModal = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cpu_rent_explain.vue